<template>
  <div class="integral-main" v-if="currentLevel != undefined">
    <div class="integral-top">
      <div class="integral-title">
        <img @click="closePage" src="@/assets/imageIntegral/close.png" alt="">
        <div>我的等级</div>
        <div @click="toRules">规则</div>
      </div>
      <swiper
        id="swiper"
        :slides-per-view="1.1"
        :space-between="0"
        :loop="false"
        :centeredSlides="true"
        :observer="true"
        :observeParents="true"
        :lazy="true"
        :initialSlide="currentLevel"
        @slideChange="onSlideChange"
        @init="swiperInit"
      >
      <!--    :key="'swiper-main' + index"
        -->
        <swiper-slide
          v-for="(item, index) in imgList"
          :key="item.total"
          class="swiper-slide-customize"
        >
          <img :src="item.url" style="width: 100%">
          <img class="logo-img" :src="item.logoUrl" :class="{ 'logo-img4':index == 4,'logo-img2':index == 2||3}">
          <img class="lock-img" :src="lock" v-show="currentLevel < index">
          <!-- <span class="experience" :style="{color: index == 4 ? '#E7C7A1' : '#fff', opacity: 0.9}" @click="toDetail(index)">
            经验值详情&nbsp;<img style="margin-top:1.5px" :src="right" v-if="index != 4"><img style="margin-top:1.5px" :src="yellowRight" v-else>
          </span> -->
          <span class="experience" v-if="currentLevel == index && currentLevel != 0">{{ retainInfo.time }}到期<template v-if="retainInfo.value > 0">前再得{{ retainInfo.value }}可保级</template></span>
          <!--  已解锁 -->
          <span class="unlocked" style="opacity: 0.9;" v-if="currentLevel > index">
            <span v-show="level > currentLevel">
              需要经验值{{item.experience}},
            </span>
            <span v-show="item.experience !== 12450">您已超越该等级</span>
            <span v-show="item.experience === 12450" :style="{color: index === 4 ? '#FCD9AB' : '#fff'}">
              <span class="is12450">{{item.experience}}</span>您已达到最高等级
            </span>
          </span>
          <!-- 待解锁 -->
          <span class="unlocked" v-if="currentLevel < index" :style="{color: index === 4 ? '#FCD9AB' : '#fff', opacity: 0.9}">
            {{item.tobeUnlockedText}}
          </span>
          <!-- 当前 -->
          <span v-if="currentLevel == index" @click="toDetail">
            <div v-if="currentLevel == 4" class="current-experience">
              <span :style="{color: index === 4 ? '#FCD9AB' : '#fff'}">
                <span class="is12450" style="margin-right: 2px">{{ currentExperience }}</span><span style="opacity: 0.8;font-size: 13px;">经验值>&nbsp;您已达到最高等级</span>
              </span>
            </div>
            <div v-else class="current-experience">
              <span>
                <span>{{currentExperience}}</span>
                经验值>&nbsp;还需<span style="margin:2px;font-size:13px">{{item.total - currentExperience}}</span>{{` 可升级lv`}}{{index+1}}
              </span>
              <nut-progress
                class="progress-my"
                :percentage="currentExperience / item.total * 100"
                :show-text="false"
                :stroke-color="item.color"
                :stroke-width="4"
              />
            </div>
          </span>
        </swiper-slide>
      </swiper>
    </div>
    <div class="integral-bottom publicPaddingLfRg">
      <p class="publicPaddingLfRg">任务权益</p>
      <div class="task-rights integral-bottom-item publicPaddingLfRg">
        <div class="rights-item" @click="toTabPage(0)">
          <img class="rights-item-badge" :src="level > 2 ? badgeMarshalling : badgePart" alt="">
          <img :src="taskTypeAll" alt="">
          <!-- <p>任务类型</p> -->
          <p>可领任务类型</p>
        </div>
        <div class="rights-item" @click="toTabPage(1)">
          <img class="rights-item-badge-2" :src="imgSrc('badge' + level)" >
          <img :src="taskNum" alt="">
          <!-- <p>任务领取数量</p> -->
          <p>任务占用上限</p>
        </div>
        <div></div>
      </div>
      <p class="publicPaddingLfRg">活动权益</p>
      <!-- 是否展示横条 -->
      <!-- at 支持webview 92以上版本 -->
      <div v-if="isDemotion && demotionOption.length > 0" class="demotionRail">
        <template v-for="item in [demotionOption[demotionOption.length - 1]]" :key="item.label">
          <div>
            <img :src="item.label == '等级快速回升' && item.originalObj.residueNumRecover > 0 ? IMAGE.imgLevelQuickRecover_little : IMAGE.imgLevelRecover_little" />
            <div class="icon_img_box">
              <b :style="{ lineHeight: '68px', height: '100%' }">{{ item.originalObj.demotionStr }}</b>
              <img :src="item.originalObj.icon" @click="showLevelRecordDialog(item.label, item.originalObj.residueNumRecover)"/>
            </div>
          </div>
          <div v-if="item.originalObj.experienceObj" class="experienceObj">
            <p></p>
            <span @click="toDetail">{{ item.originalObj.experienceObj }}</span>
          </div>
        </template>
      </div>
      <!-- 权益详情 -->
      <div class="activity-rights integral-bottom-item publicPaddingLfRg">
        <div
          v-for="item in activeTypeList"
          :key="item.label"
          :class="{colorDisabled : item.colorDisabled}"
          @click="toTabPage(item.index)"
        >
          <template v-if="!item.colorDisabled && item.hasOriginalLevel">
            <span v-if="item.originalObj.residueNumRecover != 0" :class="['orange', item.className ? item.className : '']">剩{{ item.originalObj.residueNumRecover }}次</span>
            <span v-else :class="[item.className ? item.className : '', 'use_up']">已用完</span>
          </template>
          <img v-if="!item.hasOriginalLevel" :src="item.activeImg" alt="" />
          <img v-else :src="item.colorDisabled ? item.unActiveImg : item.activeImg" alt="" />
          <p>{{ item.label }}</p>
        </div>
      </div>
    </div>
    <div class="integral-logo"><img src="@/assets/imageIntegral/logo.png"></div>
    <nut-dialog
      v-model:visible="gradingDialogShow"
      title="恭喜您保级成功！"
      textAlign="left"
      :cancelAutoClose="false"
      no-footer
      :overlay-style="{ 'zIndex': '2000' }"
    >
      <div class="dialog_info">上一等级有效期内成功完成保级条件继续加油，升级高等级，解锁更多权益！</div>
      <div class="dialog_detail" @click="gradingDialogShow = false">查看等级详情</div>
    </nut-dialog>
    <!-- 等级快速回升弹框 -->
    <nut-dialog
      v-model:visible="LevelQuickRecordDialog"
      title="权益说明"
      textAlign="left"
      :cancelAutoClose="false"
      no-footer
      :overlay-style="{ 'zIndex': '2000' }"
      >
      <div class="dialog_info">当前等级有效期结束前，完成一个审核合格任务即可恢复lv4等级。过期未使用将自动消耗次数</div>
      <div class="dialog_detail" @click="toDoTask">立即做任务</div>
    </nut-dialog>
    <img 
      v-if="LevelQuickRecordDialog || gradingDialogShow || LevelRecordDialog" 
      :src="IMAGE.closeIcon" 
      @click="closeDialog" 
      class="levelRecordDialogClose"
    />
    <!-- 等级回升弹框 -->
    <nut-dialog
      v-model:visible="LevelRecordDialog"
      title="权益说明"
      textAlign="left"
      :cancelAutoClose="false"
      no-footer
      :overlay-style="{ 'zIndex': '2000' }"
    >
      <div class="dialog_info">当前等级有效期结束前，连续3天内获得满{{ currentLevel == 3 ? '50' : '10' }}个经验值即可恢复{{ currentLevel == 3 ? 'lv4' : 'lv3' }}。过期未使用将自动消耗次数</div>
      <div class="dialog_detail" @click="toDoTask">立即做任务</div>
    </nut-dialog>
  </div>
</template>

<script>
import { 
  defineComponent, 
  getCurrentInstance, 
  reactive, 
  toRefs, 
  onMounted, 
  watch,
} from 'vue';
import { Swiper } from 'swiper/vue/swiper.js';
import { SwiperSlide } from 'swiper/vue/swiper-slide.js';
import 'swiper/swiper.scss';
import { useStore } from 'vuex';

// import VConsole from 'vconsole';


import * as IMAGE from './imgImport.js';

import request from '@/utils/request.js';
import * as api from '@/utils/apiIntegral.js';
import { Notify } from '@nutui/nutui';
// import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    // const swiper = new Swiper('#swiper',{})
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    // const vConsole = new VConsole();
    const store = useStore()
    // const router = useRouter()
    let data = reactive({
      currentLevel: undefined, // 登录人当前等级 0\1\2\3\4
      level: 0, // 滑动切换等级  页面等级
      currentExperience: 0, // 当前经验值
      isEquity: 0, // 0 未使用权益 1使用权益
      // recordResData: [], // 使用权益记录
      // 保留等级的信息
      retainInfo:{
        value: undefined, // 经验值
        time: undefined, // 时间
      },
      imgList: [ // 轮播
        { url: IMAGE.lv0, logoUrl: IMAGE.lv01, color: 'linear-gradient(90deg, #3F9CFB 0%, #0881FA 99%)', total: 1, equityTotal: 1, tobeUnlockedText: '', experience: 0 },
        { url: IMAGE.lv1, logoUrl: IMAGE.lv11, color: 'linear-gradient(90deg, #4977ED 0%, #598FFF 99%)', total: 30, equityTotal: 1, tobeUnlockedText: '需要经验值1，可领取更多任务', experience: 1 },
        { url: IMAGE.lv2, logoUrl: IMAGE.lv21, color: 'linear-gradient(137deg, #ED7D00 0%, #F19819 100%)', total: 600, equityTotal: 30, tobeUnlockedText: '需要经验值30，任务升级，开放线上活动，积分兑换', experience: 30 },
        { url: IMAGE.lv3, logoUrl: IMAGE.lv31, color: 'linear-gradient(90deg, #3E8DB0 0%, #1388BC 99%)', total: 2000, equityTotal: 600, tobeUnlockedText: '需要经验值600，最多可领取10个任务', experience: 600 },
        { url: IMAGE.lv4, logoUrl: IMAGE.lv41, color: 'linear-gradient(90deg, #3E8DB0 0%, #1388BC 99%)', total: 2000, equityTotal: 2000, tobeUnlockedText: '需要经验值2000，独享线下见面会、功能灰度特权', experience: 2000 },
      ],
      IMAGE,
      // 活动权益
      activeTypeList: [],
      // 轮播中的图片
      lock: IMAGE.lock,
      right: IMAGE.right,
      yellowRight:IMAGE.yellowRight,
      // 任务权益
      taskTypeAll: IMAGE.taskTypeAll,
      taskNum: IMAGE.taskNum,
      badge0: IMAGE.badge1,
      badge1: IMAGE.badge2,
      badge2: IMAGE.badge5,
      badge3: IMAGE.badge10,
      badge4: IMAGE.badge20,
      badgeMarshalling: IMAGE.badgeMarshalling,
      badgePart: IMAGE.badgePart,
      afterInitSwiper:'',
      // 是否传openId
      haveOpenId: null,
      gradingDialogShow: false, // 保级弹框展示
      isDemotion: false, // 是否展示等级回升横条
      demotionOption: [], // 降级的两种权益详情
      // 降级相关
      unlockState: {
        originalLevel: null,  // 降级之前的等级
        residueNumRecover: 3, // 剩余等级回升次数
        residueNumQuickRecover: 1, // 剩余快速回升次数
        experienceValue: 0, // 等级回升经验值进度
      },
      LevelQuickRecordDialog: false, // 等级快速回升弹框
      LevelRecordDialog: false, // 等级回升弹框
    });
    onMounted(() => {
      data.haveOpenId = store.getters.haveOpenId || null
      init();
    });
    const init = () => {
      let obj = {
        common: {
          "vcode":"31000008",
          "version":"3.10.0",
        },
      }
      let openId = store.getters.userInfo ? 
        store.getters.userInfo.split('/')[0] : null;
      data.haveOpenId ? obj['common']['openid'] = openId : ''
      getUserLevelInfoData(obj)
    };
    // 获取权益记录
    const getRecordData = async (obj) => {
      const recordRes = await request('post', api.userEquityRecord, obj)
      console.log(recordRes, 'recordRes');
      if(recordRes.code == 0){
        if(recordRes.data.length > 0){
          const recordData = recordRes.data
          // let recordData = [
          //   {
          //     equityType:"1",
          //     state: "2",
          //     userTime: "2023-09-15 17:44:34"
          //   },
          //   {
          //     equityType:"2",
          //     state: "1",
          //     userTime: "2023-09-15 17:44:34"
          //   },
          //   {
          //     equityType:"3",
          //     state: "1",
          //     userTime: "2023-09-15 17:44:34"
          //   },
          // ]
          // 计算快速回升次数
          recordData.find(item => item.equityType == 1 && item.state != 1) ? 
          data.unlockState.residueNumQuickRecover = 0 : data.unlockState.residueNumQuickRecover = 1
          // 计算等级回升次数
          let recordUseIndex = 0
          recordData.map(item => {
            if(item.equityType == 2 && data.unlockState.originalLevel == 4 && data.level == 4){
              recordUseIndex++;
            }
            if(item.equityType == 3 && data.unlockState.originalLevel == 3 && data.level == 3){
              recordUseIndex++;
            }
          })
          console.log(recordUseIndex);
          data.unlockState.residueNumRecover = 3 - 0 - recordUseIndex
        }
        // data.recordResData = recordRes.data
        // 改变活动权益
        changeActiveTypeList()
      }else{
        Notify.danger('获取权益记录失败');
      }
    }
    // 获取用户等级信息
    const getUserLevelInfoData = async (obj) => {
      const res = await request('post', api.userLevelInfoH5, obj)
      console.log(res, '等级信息');
      if(res.code == 0){
        const resData = res.data
        // TODO
        // 删除
        // start
        // let resData = {
        //   "currentLevel": "3",
        //   "original_level": '0', 
        //   "expiration": "2023-12-01 10:07:30", 
        //   "nextLevel": "4", 
        //   "expireValue": "50", 
        //   "expireNextValue": "9999999999", 
        //   "openSize": "1", 
        //   "openNum": "10", 
        //   "isEquity": "1", 
        //   "equityType": "1", 
        //   "isPost": "0"
        // }
        // end
        // 判断是否展示保级弹框
        data.gradingDialogShow = resData.isPost == 5 ? true : false
        data.currentExperience = resData.expireValue
        data.isEquity = Number(resData.isEquity)
        if(data.currentExperience === data.imgList[Number(resData.currentLevel)].total){
          data.currentLevel = Number(resData.currentLevel) + 1
        }else{
          data.currentLevel = Number(resData.currentLevel)
        }
        data.retainInfo.time = resData.expiration.split(' ')[0]
        data.level = data.currentLevel
        // isEquity 权益使用情况 0 未使用 1 使用中
        // equityType 
        // 1: 4->3 权益1（快速回升）; 2: 4->3 权益2（等级回升）; 3: 3->2 权益2（等级回升）
        if(data.isEquity){
          switch (resData.equityType) {
            case 1:
            case 2:
            case '1':
            case '2':
              data.unlockState.originalLevel = 4  // 原始等级，在没有降级时和用户等级一致
              break;
            case 3:
            case '3':
              data.unlockState.originalLevel = 3  // 原始等级，在没有降级时和用户等级一致
              break;
            default:
              data.unlockState.originalLevel = data.currentLevel
              break;
          }
        }else{
          data.unlockState.originalLevel = data.currentLevel
        }
        data.retainInfo.value = data.imgList[data.currentLevel].equityTotal - data.currentExperience
        // 获取用户经验值，通过经验值给data.unlockState.experienceValue赋值
        getUserExperience(obj, resData.expiration)
        process.nextTick(() => {
          swiperInit(data.afterInitSwiper)
        })
      }else{
        Notify.danger('获取等级信息失败');
      }
    }
    const getUserExperience = async (obj, expiration) => {
      if(data.isEquity){
        const relatedDetailRes = await request('post', api.userLevelRelatedDetailList, obj)
        console.log(relatedDetailRes, 'relatedDetailRes');
        if(relatedDetailRes.code === 0){
          if(relatedDetailRes.data.list.length > 0){
            let dataTime = expiration.split('-')
            // 判断有没有跨年
            if(dataTime[0] > new Date().getFullYear()){
              dataTime[1] = (dataTime[0] - new Date().getFullYear() + 12)  - 3
              dataTime[0] = dataTime[0] - 1
            }else{
              dataTime[1] = dataTime[1] - 3
            }
            dataTime = dataTime.join('-')
            // 大于前一段有效期，小于当前有效期
            data.unlockState.experienceValue = relatedDetailRes.data.list.filter(item => item.amount > 0)
            .filter(item => (((new Date().getTime() - 259200000) < new Date(item.time).getTime()) && (new Date(dataTime).getTime() < new Date(item.time).getTime())))
            .map(item => Number(item.amount)).reduce((pre, cur) =>pre + cur, 0)
          }
          getRecordData(obj)
        }else{
          Notify.danger('获取等级明细失败');
        }
      }else{
        // 获取权益记录
        getRecordData(obj)
      }
    }
    const changeActiveTypeList = () => {
      data.activeTypeList = [
        {
          colorDisabled: `${data.level < 2}`,
          label: '线上活动',
          activeImg: `${data.level < 2 ? IMAGE.unActivities : IMAGE.activities}`,
          hasOriginalLevel: false,
          index: 2,
        },
        {
          colorDisabled: `${data.level < 2}`,
          label: '积分兑换',
          activeImg: `${data.level < 2 ? IMAGE.unMall : IMAGE.mall}`,
          hasOriginalLevel: false,
          index: 3,
        },
        {
          colorDisabled: `${ data.level <= 3}`,
          label: '线下见面会',
          activeImg: `${ data.level <= 3 ? IMAGE.unMeet : IMAGE.meet}`,
          hasOriginalLevel: false,
          index: 4,
        },
        {
          colorDisabled: `${ data.level <= 3}`,
          label: '功能优先体验',
          activeImg: `${ data.level <= 3 ? IMAGE.unExclusive : IMAGE.exclusive}`,
          hasOriginalLevel: false,
          index: 5,
        },
      ]
      // 调整lv3和lv4的权益展示顺序
      const objLv3 = {
        colorDisabled: false, // 是否展示LV3未解锁状态
        label: '等级回升',
        activeImg: IMAGE.imgLevelRecover,
        unActiveImg: IMAGE.imgLevelRecover_grey,
        hasOriginalLevel: true,
        index: 6,
        originalObj:{
          residueNumRecover: data.unlockState.residueNumRecover, // 回升次数
          demotionStr: '您由LV3降级到LV2，可使用等级回升特权',
          originLevel: 3, // 针对目标等级
          icon: IMAGE.yellowRight,
          experienceObj: `经验值获取进度:${data.unlockState.experienceValue}/10个 >`
        },
      }
      const objLv4 = {
        colorDisabled: false, // 是否展示LV4未解锁状态
        label: '等级快速回升',
        activeImg: IMAGE.imgLevelQuickRecover,
        unActiveImg: IMAGE.imgLevelQuickRecover_grey,
        hasOriginalLevel: true,
        className: 'leftCol',
        index: 7,
        originalObj:{
          residueNumRecover: data.unlockState.residueNumQuickRecover, // 快速回升次数
          demotionStr: data.unlockState.residueNumQuickRecover == 0 ? 
          '您由LV4降级到LV3，可使用等级回升特权' : '您由LV4降级到LV3，可使用等级快速回升特权',
          originLevel: 4,
          icon: IMAGE.yellowRight,
          experienceObj: data.unlockState.residueNumQuickRecover == 0 ? 
          `经验值获取进度:  ${data.unlockState.experienceValue}/50个 >` : ''
        }
      }
      // 降级
      if(data.isEquity == 1){
        if(data.level == 3){
          data.demotionOption = [objLv3]
          data.activeTypeList.splice(2, 0, objLv3)
          data.activeTypeList.push({})
        }
        if(data.level == 4){
          objLv3['colorDisabled'] = true
          objLv4['colorDisabled'] = true
          data.demotionOption = [objLv3, objLv4]
          data.activeTypeList.push(...data.demotionOption, data.currentLevel == 3 ? {} : '')
        }
        if(data.currentLevel == 2){
          data.demotionOption = [objLv3]
          if(data.level == 3){
            objLv3['colorDisabled'] = true
          }
        }
        if(data.currentLevel == 3){
          data.demotionOption = [objLv4]
        }
      }else{
        // 当前lv3滑块不等于lv4
        if((data.currentLevel == 3 && data.level != 4) || data.level == 3){
          if(data.currentLevel == 3 && data.level != 3){
            return
          }
          if(data.level == 3 && data.currentLevel != 3){
            objLv3['colorDisabled'] = true
          }
          data.demotionOption = [objLv3]
          data.activeTypeList.splice(2, 0, ...data.demotionOption)
          data.activeTypeList.push({})
        }
        if(data.currentLevel == 4 || data.level == 4){
          if(data.currentLevel == 4 && data.level != 4){
            return
          }
          if(data.level == 4 && data.currentLevel != 4){
            objLv3['colorDisabled'] = true
            objLv4['colorDisabled'] = true
          }
          data.demotionOption = [objLv3, objLv4]
          data.activeTypeList.push(...data.demotionOption, data.currentLevel == 3 ? {} : '')
        }
      }
      data.isDemotion = data.isEquity == 1 && data.level == data.currentLevel ? true : false
    }
    const showLevelRecordDialog = (label, num) => {
      if(label == '等级快速回升' && num > 0){
        data.LevelQuickRecordDialog = true
      }else{
        data.LevelRecordDialog = true
      }
    }
    const toDoTask = () => {
      // 跳转到首页
      window.easyearn.goMainEntryPage()
    }
    // const goToDetailPage = () => {
    //   router.push('/integral/detail')
    // }
    const closePage = () => {
      window.easyearn.goBack()
    };
    const onSlideChange = (event) => {
      data.level = event.realIndex;
    };
    const swiperInit = (event) => {
      data.afterInitSwiper = event
      if(data.currentLevel != undefined){
        event.activeIndex = data.currentLevel
        event.update()
      }
    };
    watch(() => data.level,(nv,ov)=>{
      if(nv != ov){
        beacon.onUserAction('user_level_switch',{
          leve:data.level,
          user_level:data.currentLevel
        })
        changeActiveTypeList()
      }
    })
    const imgSrc = (str) => data[str];
    const toRules = () => {
      beacon.onUserAction('level_rules_click')
      window.location.pathname = '/integral/rules';
    };
    const toDetail = () => {
      // beacon.onUserAction('level_detail_click')
      // if (data.currentLevel >= index) window.location.pathname = '/integral/detail';
      window.location.pathname = '/integral/detail';
    };
    // 关闭弹框
    const closeDialog = () => {
      data.LevelQuickRecordDialog = false;
      data.gradingDialogShow = false;
      data.LevelRecordDialog = false;
    }
    const toTabPage = (index) => {
      if(index == undefined) return
      if(index == 0){
        toTabPageFun('privilege_01_click')
      }
      if(index == 1){
        toTabPageFun('privilege_02_click')
      }
      if(index == 2){
        toTabPageFun('privilege_11_click')
      }
      if(index == 3){
        toTabPageFun('privilege_12_click')
      }
      if(index == 4){
        toTabPageFun('privilege_13_click')
      }
      if(index == 5){
        toTabPageFun('privilege_14_click')
      }
      if(index == 6){
        toTabPageFun('privilege_15_click')
      }
      if(index == 7){
        toTabPageFun('privilege_16_click')
      }
      const href = window.location.href.split('integral/');
      window.location.href = `${href[0]}integral/rights?
      level=${data.currentLevel}&isEquity=${data.isEquity}&tabLevel=${data.level}&tab=${index}`
    };
    const toTabPageFun = (FunName) => {
      beacon.onUserAction(FunName, {
        is_locked: data.currentLevel > data.level ? 1 : 0,
        user_level: data.currentLevel,
        page_level: data.level
      })
    }
    return {
      ...toRefs(data),
      init,
      closePage,
      onSlideChange,
      swiperInit,
      imgSrc,
      toRules,
      toDetail,
      toTabPage,
      toTabPageFun,
      changeActiveTypeList,
      closeDialog,
      showLevelRecordDialog,
      toDoTask,
      // goToDetailPage,
      getRecordData,
      getUserExperience,
      getUserLevelInfoData,
    };
  },
})
</script>

<style lang="scss" scoped>
.publicPaddingLfRg{
  padding: 0 24px;
}
.integral-main {
  background-color: #F4F4FB;
  height: 100%;
  .integral-top {
    padding: 13px 0 30px 0;
    background: url("~@/assets/imageIntegral/bg.png") no-repeat -160px 0;;
    .integral-title {
      padding: 0 20px 34px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #FFFFFF;
      img {
        width: 20px;
      }
      div:first-of-type {
        font-size: 16px;
      }
      div:last-of-type {
        font-size: 12px;
      }
    }
    .swiper-slide-customize {
      position: relative;
      .logo-img {
        position: absolute;
        top: 15px;
        right: 18px;
        width: 96px;
      }
       .logo-img2 {
        position: absolute;
        top: 15px;
        right: 18px;
        width: 103px;
      }
      .logo-img4 {
        position: absolute;
        top: 15px;
        right: 13px;
        width: 130px;
        // height: 120px;
      }
      .lock-img {
        position: absolute;
        right: -2px;
        top: -3px;
        width: 26px;
      }
      .experience {
        display: flex;
        align-items: center;
        color: #fff;
        position: absolute;
        top: 56px;
        left: 12px;
        font-size: 12px;
        img {
          width: 12px;
        }
      }
      .jian_tou{
        position: absolute;
        top: 50%;
        right: -16px;
        width: 0;
        height: 0;
        border: 5.5px solid;
        margin-top: -5px;
        border-color: transparent transparent transparent #FCD9AB;
      }
      .jian_tou2{
        position: absolute;
        top: 50%;
        right: -5px;
        width: 0;
        height: 0;
        border: 6px solid;
        margin-top: -6px;
        border-color: transparent transparent transparent #1F2438;
      }
      .unlocked {
        color: #fff;
        position: absolute;
        font-size: 12px;
        bottom: 20px;
        left: 12px;
        .is12450 {
          font-size: 16px;
        }
      }
      .current-experience {
        position: absolute;
        bottom: 18px;
        left: 12px;
        color: #fff;
        font-size: 12px;
        span {
          span {
            font-size: 16px;
          }
        }
        .progress-my {
          margin-top: 6px;
          width: 302px;
          // opacity: .4;
        }
      }
    }
  }
  .integral-bottom {
    transform: translateY(-10px);
    background-color: #fff;
    border-radius: 10px;
    padding: 22px 0 34px;
    p {
      font-size: 20px;
      font-weight: bold;
    }
    .demotionRail{
      background-color: rgb(254, 241, 224);
      img{
        width: 4%;
      }
      & > div {
        display: flex;
        & > img{
          vertical-align: middle;
          width: 8%;
          height: 8%;
          margin: 3% 0 2% 3%;
        }
      }
      .icon_img_box{
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: space-between;
        padding: 0 3%;
        img{
          border: 1px solid rgb(245, 154, 35);
          border-radius: 50%;
        }
        b{
          display: inline-block;
          font-size: 12px;
        }
      }
      .experienceObj{
        height: 30px;
        & > :nth-child(1){
          width: 13%;
        }
        & > :nth-child(2){
          flex: 1;
          margin: 0;
          padding: 0;
          font-size: 12px;
          margin-left: 3%;
          color: rgb(174, 173, 172);
        }
      }
    }
    .integral-bottom-item {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .colorDisabled {
        color: #919191;
      }
      div {
        width: 25%;
        text-align: center;
        box-sizing: content-box;
        position: relative;
        img {
          width: 44px;
        }
        p {
          margin-top: 2px;
          font-size: 12px;
          font-weight: 400;
        }
        span{
          display: inline-block;
          position: absolute;
          top: 20%;
          right: 0;
          padding: 1%;
          border-radius: 50px;
          font-size: 9px;
          width: 28px;
          background-color: rgb(85, 85, 85);
          color: white;
        }
        span.use_up{
          width: 31px;
        }
        // span.leftCol{
        //   right: 25%;
        // }
        span.orange{
          color: rgb(51, 51, 51);
          background-color: rgb(246, 182, 113);
        }
      }
      div:first-of-type {
        padding-right: 8.3%;
      }
      div:nth-of-type(3n + 1) {
        padding-right: 8.3%;
      }
       div:nth-of-type(3n) {
        padding-left: 8.3%;
      }
    }
    .task-rights {
      padding: 22px 24px 40px;
      .rights-item {
        position: relative;
        .rights-item-badge {
          width: 28px;
          position: absolute;
          top: -2.9px;
          right: 24%;
        }
        .rights-item-badge-2 {
          width: 30px;
          position: absolute;
          top: -2.9px;
          right: 0%;
        }
      }
    }
    .activity-rights {
      div {
        padding: 21px 0 0 ;
      }
    }
  }
  .integral-logo {
    transform: translateY(-10px);
    background-color: #F4F4FB;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0 16px 0;
    img {
      width: 70px;
    }
  }
  .levelRecordDialogClose{
    position: fixed;
    right: 5%;
    top: 30%;
    z-index: 2003;
    width: 7%;
  }
  & :deep(.nut-dialog__header){
    font-size: 16px;
    font-weight: bold;
    padding: 2px 0;
    height: 26px;
    line-height: 26px;
  }
  & :deep(.nut-dialog__content){
    overflow: visible;
    margin-bottom: 0;
  }
  .dialog_info{
    font-weight: 500;
    font-size: 16Px;
    color: #000000;
    line-height: 21Px;
  }
  .dialog_detail{
    margin-top: 40px;
    color: #0088FF;
    text-align: center;
    font-size: 16px;
  }
}
</style>
